const prefix = '/api/'

export const CommonApiPrefix = prefix.concat('co')
export const ObjectSecProfileApiPrefix = prefix.concat('op')
export const DashboardApiPrefix = prefix.concat('da')
export const AnalysisApiPrefix = prefix.concat('an')
export const LogReportApiPrefix = prefix.concat('lr')
export const SecutiryPolicyApiPrefix = prefix.concat('po')
export const VpnApiPrefix = prefix.concat('vp')
export const SystemApiPrefix = prefix.concat('sm')
// TAMS
export const CmApiPrefix = prefix.concat('cm')
export const PamsApiPrefix = prefix.concat('pm')
